import { render, staticRenderFns } from "./NewSimpleAppointmentModal.vue?vue&type=template&id=c833837c&scoped=true&"
import script from "./NewSimpleAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./NewSimpleAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./NewSimpleAppointmentModal.vue?vue&type=style&index=0&id=c833837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c833837c",
  null
  
)

export default component.exports